import React from 'react';

interface ScreenContainerProps {
    pageTitle: string;
    children: React.ReactNode;
}

/**
 * The centred single-column screen layout used by every step of the login/signup flow,
 * matching televeda-bootstrap's `pages/login.html` structure.
 */
const ScreenContainer = ({ pageTitle, children }: ScreenContainerProps) => (
  <>
    <h1 className='visually-hidden'>{pageTitle}</h1>
    <div className='row flex-grow-1 h-100 justify-content-center align-items-center'>
      <div className='col-12 col-md-6 col-lg-4'>
        {children}
      </div>
    </div>
  </>
);

export default ScreenContainer
